import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'

import 'styles/status-message.pcss'
import ErrorMessageContent from './ErrorMessageContent'

const PaymentProcessAlreadyStarted = ({ appError }) => {
    const { t, i18n } = useTranslation(['errors'])

    const data = appError.data
    const bosId = data.bosId

    return (
        <ErrorMessageContent
            title={t('errors:omanettix.10063.title')}
            content={(
                <p>
                    <Trans i18nKey="errors:omanettix.10063.message">
                        Payment process already started, wait for status update.
                        <Link to={`${getLocale(i18n.language)}/fiksut-kaupat/sahkoinen-kauppakirja/${bosId}`} trackName="showBos">Go to Bos</Link>
                    </Trans>
                </p>
            )}
        />
    )
}

export default withRouter(PaymentProcessAlreadyStarted)
